import React, { memo, useContext, useState, useEffect } from "react";
import getStructure from "../utils/preParser";
import Parser from "./parser";
import { Context } from "./context";
const PreParser = memo(({ children, breadcrumbs, ...props }) => {
    const context = useContext(Context);
    const [structure, setStructure] = useState([]);
    const effect = () => {
        setStructure((oldStructure) => {
            const newStructure = getStructure({
                children,
                breadcrumbs,
                structure: props.structure,
                customBreadcrumbs: context.settings.metadata.customBreadcrumbs,
            });
            return newStructure;
        });
    };
    useEffect(effect, [children, props.structure]);
    if (typeof window === "undefined" &&
        !structure.length &&
        props.structure?.length) {
        effect();
    }
    return (React.createElement(React.Fragment, null, props.structure.length ? React.createElement(Parser, { structure: structure }) : React.createElement(React.Fragment, null)));
});
export default PreParser;
